var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Row, Col } from "react-bootstrap";
import { H2, H4 } from "@irati/ui/src/Typography";
import { Label3 } from "@irati/ui/src/Labels";
import Form from "@irati/ui/src/Form";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Validation from "@irati/utils/validation";
import Header from "@irati-web/fields/companyBenefits/Header";
import SavingsValue from "@irati-web/fields/companyBenefits/SavingsValue";
import SavingsType from "@irati-web/fields/companyBenefits/SavingsType";
import CardImage from "@irati-web/fields/companyBenefits/CardImage";
import { Hidden } from "@irati/ui/src/FormItem";
import TeamSelect from "@irati-web/fields/companyBenefits/TeamSelect";
import Flex from "@irati/ui/src/Flex";
import Div from "./styled/Div";
import ErrorWrapper from "./styled/ErrorWrapper";
import { DESCRIPTION } from "./Popup";
import WhoCanSee, { WhoCanSeeCompanyBenefit } from "./fields/WhoCanSee";
var CardStep = /** @class */ (function (_super) {
    __extends(CardStep, _super);
    function CardStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            whoCanSee: WhoCanSeeCompanyBenefit.Tenant
        };
        _this.handleWhoCanSee = function (whoCanSee) {
            _this.setState({ whoCanSee: whoCanSee });
            if (whoCanSee === WhoCanSeeCompanyBenefit.Tenant) {
                _this.props.onChange("teamIds", []);
            }
        };
        return _this;
    }
    CardStep.getDerivedStateFromProps = function (props, state) {
        var _a;
        var benefit = props.benefit;
        var whoCanSee = state.whoCanSee;
        if (benefit.uuid !== ((_a = state.benefit) === null || _a === void 0 ? void 0 : _a.uuid)) {
            var hasWhitelist = benefit.teamIds.length;
            whoCanSee = hasWhitelist ? WhoCanSeeCompanyBenefit.Team : WhoCanSeeCompanyBenefit.Tenant;
        }
        return { whoCanSee: whoCanSee, benefit: benefit };
    };
    CardStep.prototype.schema = function () {
        return Validation.mixed().test("ok", this.props.formatMessage({ id: "admin.components.card.savingsSchema.validation" }), function (benefit) {
            var _a = benefit.savings.userSavings, value = _a.value, type = _a.type;
            return !((!value && type) || (value && !type));
        });
    };
    Object.defineProperty(CardStep.prototype, "edit", {
        get: function () {
            return !!this.props.benefit.cardImage;
        },
        enumerable: false,
        configurable: true
    });
    CardStep.prototype.render = function () {
        var _a = this.props, show = _a.show, benefit = _a.benefit, onChange = _a.onChange, selectStep = _a.selectStep, formatMessage = _a.formatMessage, hideBannerImageUpload = _a.hideBannerImageUpload;
        var whoCanSee = this.state.whoCanSee;
        if (!show) {
            return null;
        }
        return (React.createElement(Div, null,
            React.createElement(Flex, { direction: "column", alignItems: "center" },
                React.createElement(Label3, { uppercase: true },
                    React.createElement(FormattedMessage, { id: "admin.components.card.stepOne" })),
                React.createElement(H2, null,
                    React.createElement(FormattedMessage, { id: "admin.components.card.headerTwo.companyBenefit" })),
                React.createElement(H2, null,
                    React.createElement(FormattedMessage, { id: "admin.components.card.headerTwo.card" })),
                React.createElement(H4, { margin: "40px 0 60px" },
                    React.createElement(FormattedMessage, { id: "admin.components.card.headerFour.defineBenefit" }))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(Form, { form: "create-company-benefit-step1" },
                        React.createElement(Col, { md: 12 },
                            React.createElement(WhoCanSee, { value: whoCanSee, onChange: this.handleWhoCanSee })),
                        whoCanSee === WhoCanSeeCompanyBenefit.Team && (React.createElement(Col, { md: 12 },
                            React.createElement(TeamSelect, { value: benefit.teamIds, onChange: function (values) { return onChange("teamIds", values.map(function (_a) {
                                    var value = _a.value;
                                    return value;
                                })); } }))),
                        React.createElement(Col, { md: 12 },
                            React.createElement(Header, { benefit: benefit, onChange: onChange })),
                        React.createElement(Col, { md: 8 },
                            React.createElement(SavingsValue, { benefit: benefit, onChange: onChange })),
                        React.createElement(Col, { md: 4 },
                            React.createElement(SavingsType, { benefit: benefit, onChange: onChange })),
                        React.createElement(Col, { md: 12 },
                            React.createElement(ErrorWrapper, null,
                                React.createElement(Hidden, { name: "savings", value: benefit, validation: this.schema() }))),
                        React.createElement(Col, { md: 12 },
                            React.createElement(CardImage, { benefit: benefit, edit: this.edit, onChange: onChange, heading: "admin.components.cardImage.heading.benefitImage", name: "benefit_card_image", property: "cardImage", width: 360, height: 160 })),
                        !hideBannerImageUpload && (React.createElement(Col, { md: 12 },
                            React.createElement(CardImage, { benefit: benefit, edit: this.edit, onChange: onChange, validation: function () { return Validation.string(); }, heading: "admin.components.cardImage.heading.benefitBanner", name: "benefit_banner_image", property: "bannerImage", width: 1920, height: 350 }))))),
                React.createElement(Col, { xs: 12 },
                    React.createElement(Flex, { justifyContent: "center" },
                        React.createElement(ValidationButton, { primary: true, large: true, loading: formatMessage({ id: "admin.components.card.validationButton.loading" }), onClick: function () { return selectStep(DESCRIPTION); } },
                            React.createElement(FormattedMessage, { id: "admin.components.card.validationButton.continue" })))))));
    };
    return CardStep;
}(Component));
export default injectIntl(CardStep);
